import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.is), null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.childIs), {
        style: `height: ${_ctx.virtualPaddingTop}px`
      }, null, 8, ["style"])),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.virtualList, ({ item, index }) => {
        return _renderSlot(_ctx.$slots, "default", {
          key: index,
          item: item,
          index: index
        })
      }), 128)),
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.childIs), {
        style: `height: ${_ctx.virtualPaddingBot}px`
      }, null, 8, ["style"])),
      _renderSlot(_ctx.$slots, "extra")
    ]),
    _: 3
  }))
}